<div class="warp-white">
    <div class="grid-header">
        <div class="fixed-25 list-item" translate>column.name</div>
        <div class="flex-1" *ngIf="isDisplayUser$() && !isGeneralQuestionnaires$()" translate>column.questionnaireNumber</div>
        <div class="flex-1" translate>column.category</div>
        <div class="flex-1" *ngIf="!isMyQuestionnaires$()" translate>column.date</div>
        <div class="flex-1" *ngIf="!isGeneralQuestionnaires$()" translate>column.submissionDate</div>
        <!-- <div class="flex-1" *ngIf="isByFolders"> מיקום</div> -->
        <div class="flex-1_8" *ngIf="!isDisplayUser$()" translate>column.group</div>
        <!-- <div class="flex-recip"translate  *ngIf="!isUser$()" >column.reply</div>
<div class="flex-recip"translate  *ngIf="!isUser$()" >column.not-reply</div> -->
        <div class="flex-1" *ngIf="!isGeneralQuestionnaires$()" translate>column.status</div>
        <div class="flex-1_8" *ngIf="isExpenseEnv == 'ON' && isMyQuestionnaires$()" translate>column.extraDetails</div>
        <div class="flex-half last"></div>
    </div>
</div>